import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pricingTiers = [{
  name: "Casual User",
  price: "€0",
  description: "Pay-as-you-go charging for people on the move.",
  features: ["First 30 mins free *", "Access to 100+ stations", "24/7 app support", "No monthly fees", "Return anywhere"],
  featured: false
}, {
  name: "Venue Partner",
  price: "€0*",
  description: "Boost your foot traffic and earn extra income.",
  features: ["Free station installation", "Revenue share on rentals", "Featured in Zapgo app", "Maintenance included", "Real-time analytics", "Marketing toolkit"],
  featured: true
}, {
  name: "Event Network",
  price: "Custom",
  description: "High-capacity power solutions for large-scale events.",
  features: ["Bulk powerbank delivery", "Branded charging hubs", "On-site technical staff", "Custom rental durations", "Priority replenishment", "Dedicated event manager", "Happy customers -> SUCCESFUL event!"],
  featured: false
}];
export default function Pricing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="47672" id="pricing" ref={ref} className={`bg-background text-foreground py-24 sm:py-32 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-primary font-mono font-semibold tracking-widest uppercase text-sm mb-3">
            Power Plans
          </h2>
          <p className="mt-2 text-4xl font-sans font-extrabold tracking-tight text-foreground sm:text-5xl">
            Never Run Out of Battery
          </p>
          <p className="mt-6 text-lg leading-8 text-muted-foreground font-sans">
            Whether you're a commuter needing a quick boost or a business owner
            looking to attract more customers, we have the perfect solution.
          </p>
        </div>

        <div className="mx-auto grid max-w-md grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
          {pricingTiers.map((tier, i) => <div key={tier.name} data-index={i} className={`flex flex-col ${tier.featured ? "lg:-mt-4 lg:mb-4" : ""}`}>
              <Card className={`flex flex-col justify-between h-full bg-card/50 backdrop-blur-sm text-card-foreground transition-all duration-300 hover:shadow-xl ${tier.featured ? "border-primary border-2 shadow-[0_0_30px_rgba(34,197,94,0.2)] scale-105 z-10 relative" : "border-border/50 border hover:border-primary/40"} rounded-3xl`}>
                <CardHeader>
                  <CardTitle className="text-xl font-sans font-bold text-foreground">
                    {tier.name}
                  </CardTitle>
                  <div className="mt-4 flex items-baseline text-foreground">
                    <span className="text-5xl font-mono font-bold tracking-tighter text-primary">
                      {tier.price}
                    </span>
                    {tier.price !== "Custom" && tier.price !== "€0" && tier.price !== "€0*" && <span className="ml-1 text-xl font-sans text-muted-foreground">
                        /hr
                      </span>}
                  </div>
                  <CardDescription className="mt-4 text-muted-foreground font-sans leading-relaxed">
                    {tier.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul role="list" className="space-y-4">
                    {tier.features.map((feature, featureIndex) => <li key={featureIndex} data-index={featureIndex} className="flex items-start gap-3">
                        <Check className="h-5 w-5 flex-none text-primary shrink-0" />
                        <span className="text-sm text-muted-foreground font-sans">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </CardContent>
                <CardFooter className="mt-auto pt-6">
                  <Button asChild className={`w-full font-sans font-bold text-base py-6 rounded-full transition-all duration-300 ${tier.featured ? "bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-[0_0_20px_rgba(34,197,94,0.4)]" : "bg-secondary text-secondary-foreground hover:bg-secondary/80"}`}>
                    <Link to={tier.price === "Custom" ? "/SupportPage" : "/PartnersPage"}>
                      {tier.price === "Custom" ? "Contact Sales" : tier.featured ? "Become a Partner" : "Download App"}
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}